export default __webpack_public_path__ + "static/media/document.c2fd1693.svg";